import { ApolloProvider as Provider } from "@apollo/client";
import { PropsWithChildren } from "react";
import { apolloClient } from "./apolloClient";

export function ApolloProvider({ children }: PropsWithChildren<{}>) {
	return <Provider client={apolloClient}>{children}</Provider>;
}
